// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RHa0","index":"styles_index__36y_Q"};